import { AuthLayout } from "app/auth/components";
import React from "react";
import VerifyEmailIlustration from "assets/verify-email.svg";
import CheckIcon from "@mui/icons-material/Close";
import Logo from "assets/logo.png";

export const EmailVerificationErrorPage = () => {
  return (
    <AuthLayout
      ilustration={VerifyEmailIlustration}
      title="Verificación de email"
      subtitle=""
      logo={Logo}
    >
      <div className="max-w-xl flex flex-col items-center">
        <h1 className="text-center font-bold text-2xl my-4">
          Hubo un error al verificar su email
        </h1>
        <div className="h-60">
          <div className="flex flex-col items-center transition delay-300 duration-300 ease-in-out">
            <h2>Intente nuevamente más tarde</h2>
            <div className="rounded-full bg-primary-600 p-4 text-white m-4">
              <CheckIcon />
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};
